import React, { useRef, useEffect } from "react";
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import { useNavigate, Link  } from 'react-router-dom';
import { useCategory } from '../components/CategoryContext';
import { Container, Row, Col} from "react-bootstrap";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { Helmet } from 'react-helmet';
import '../styles/Home.css';
import '../styles/Image.css';
import '../styles/CustomButton.css';


const Home = () => {
  const videoRef = useRef(null);
  const { groups, categories } = useCategory();
  const navigate = useNavigate();
  useEffect(() => {
    const video = videoRef.current;

    const handleVideoEnded = () => {
      // При завершении видео, возвращаемся к началу и воспроизводим снова
      video.currentTime = 0;
      video.play();
    };

    // Добавляем обработчик события 'ended'
    video.addEventListener('ended', handleVideoEnded);

    // Убираем обработчик события при размонтировании компонента
    return () => {
      video.removeEventListener('ended', handleVideoEnded);
    };
  }, []); // Пустой массив зависимостей означает, что эффект выполняется только при монтировании компонента
  const handleButtonClick = (url) => {
    // Используем find для поиска соответствия по url
    const selectedGroup = groups.find((group) => group.url === url);
  
    // Если соответствующая группа найдена
    if (selectedGroup) {
      // Используем filter для нахождения элементов Category с соответствующей группой
      const filteredItems = categories.filter((item) => item.group === selectedGroup.url);
  
      // Обновляем состояние или используем для отображения результатов
      console.log(filteredItems);
    }
  
    navigate(`/category/${encodeURIComponent(url)}`);
  };
    return(
        <div >
        <Helmet>
        <title>Kromsan мебель для промышленных кухонь</title>
        <meta name="description" content="МЕБЕЛЬ ИЗ ВЫСОКОКАЧЕСТВЕННОЙ НЕРЖАВЕЮЩЕЙ СТАЛИ AISI 304 И AISI 430, оборудование для кухни, комплексное оснащение гостиниц и ресторанов, HORECA, Kromsan" />
      </Helmet>
      <div style={{ width: '100%' }}>
      <video ref={videoRef} width="100%" height="auto" controls autoPlay muted controlsList="nodownload">
        <source src="images/video_kromsan.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <br/>
    <div className="center-cards d-flex justify-content-center">
      <Row>
        <CardGroup className="mt-1">
          {groups.map((item) => (
            <Col key={item.id} style={{ margin: '15px' }}>
              <Card className="mb-4" style={{ width: '25rem', border: '1px solid transparent', backgroundColor: 'transparent' }}>
                <Card.Img height={300} variant="top" src={item.image} />
                <Card.Body className="text-center d-flex flex-column justify-content-between">
                  <Card.Title>{item.name}</Card.Title>
                  <Card.Text style={{ height: '100px', overflow: 'hidden' }}>{item.description}</Card.Text>
                  
                  <Link to={`/category/${encodeURIComponent(item.url)}`} onClick={() => handleButtonClick(item.url)}>
  <Button className="CustomButton" variant="primary" >Показать элементы</Button>
</Link>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </CardGroup>
      </Row>
      </div>
      
    <div style={{ background: 'RGB(209,211,211)' }}>
 <Container className="pt-3 pb-3"  >

  <h1>Основные принципы KROMSAN:</h1>
  <ul>
    <li>Клиентоориентированность: Наша команда стремится полностью удовлетворить потребности клиентов, предоставляя индивидуальные решения и оперативное обслуживание.</li>
    <li>Инновации и технологии: Мы постоянно внедряем новые технологии и инновации в производственные процессы, чтобы обеспечивать наших клиентов современными и эффективными решениями.</li>
    <li>Экологическая ответственность: KROMSAN придерживается экологически устойчивых практик, выбирая материалы и технологии, которые сокращают негативное воздействие на окружающую среду.</li>
    <li>Индивидуальный дизайн: Мы гордимся тем, что можем предоставить нашим клиентам индивидуальные дизайнерские решения, созданные с учетом их уникальных требований и предпочтений.</li>
  </ul>
 </Container>
 <Container>
      <Row className="mb-4">
        <Col sm={4} md={4} lg={4} xl={4} className="mb-4">
          <div className="hover-image-scale">
            <Image src="images/home1.jpg" width={350} height={350} alt="Kromsan" className="hover-image-scale" />
          </div>
        </Col>
        <Col sm={4} md={4} lg={4} xl={4} className="mb-4">
          <div className="hover-image-scale">
            <Image src="images/home2.png" width={350} height={350} alt="Kromsan" className="hover-image-scale" />
          </div>
        </Col>
        <Col sm={4} md={4} lg={4} xl={4} className="mb-4">
          <div className="hover-image-scale">
            <Image src="images/home4.jpg" width={350} height={350} alt="Kromsan" className="hover-image-scale" />
          </div>
        </Col>
      </Row>
      
    </Container>
 <ScrollAnimation animateIn="animate__slideInLeft">
 <hr className="featurette-divider"></hr>
 <div className="row featurette">
      <div className="col-md-7">
        <h1 className="featurette-heading fw-normal lh-1">Контроль качества</h1>
        <p>Контроль качества является фундаментальным принципом в производстве нашей мебели.
           Мы гарантируем высокое качество каждого изделия, начиная с материалов, которые мы используем. 
           Наша мебель изготавливается из высококачественной нержавеющей стали AISI 304 и AISI 430, предоставляемой 
           ведущими мировыми производителями из Турции, России и Европы.
Мы стремимся использовать только лучшие материалы, чтобы обеспечить надежность,
 долговечность и современный стиль нашей мебели. Нержавеющая сталь AISI 304 и AISI 430 обеспечивает
  высокую степень коррозионной стойкости, что делает нашу мебель идеальным решением для промышленных кухонь,
   ресторанов и других предприятий, где важны стандарты качества и гигиены.
 Наши поставщики являются гарантом высоких стандартов металлургии, что подчеркивает наше стремление к безупречности в каждой детали.</p>
      </div>
      <div className="col-md-5">
        <Image src="/images/img_001.jpg" width={300} height={300}/>
      </div>
    </div>
    </ScrollAnimation>
    <ScrollAnimation animateIn="animate__slideInRight">
    <hr className="featurette-divider"></hr>
    <div className="row featurette">
      <div className="col-md-7 order-md-2">
        <h1 className="featurette-heading fw-normal lh-1">Оперативность</h1>
        <p>Оперативность - один из ключевых аспектов нашей работы. Мы предоставляем гарантийное и сервисное обслуживание на всё
           поставленное оборудование, чтобы обеспечить наших клиентов надежным и бесперебойным функционированием. Наша команда специалистов 
           готова оперативно реагировать на любые запросы и обеспечивать профессиональное обслуживание в случае необходимости.
Гарантийное обслуживание включает в себя обеспечение клиентов качественными и долговечными решениями, а также обеспечение
 соблюдения всех гарантийных условий. Мы стремимся поддерживать наше оборудование в отличном состоянии, чтобы обеспечить долгий срок его службы.
Сервисное обслуживание предоставляется нашими опытными техническими специалистами, которые готовы ответить на
 вопросы, предоставить консультации и оперативно реагировать на любые технические неполадки. Наша цель - обеспечить бесперебойную работу вашего оборудования,
 чтобы вы могли сосредоточиться на своем бизнесе, зная, что вы можете полагаться на надежность и оперативность нашего сервиса.</p>
      </div>
      <div className="col-md-5 order-md-1">
      <Image src="/images/img_002.jpg" width={300} height={300}/>
      </div>
    </div>
    </ScrollAnimation>
    <Container>
    <Row className="mb-2 mt-4">
        <Col sm={4} md={4} lg={4} xl={4} className="mr-2">
          <div className="hover-image-scale">
            <Image src="images/home3.png" width={350} height={350} alt="Kromsan" className="hover-image-scale" />
          </div>
        </Col>
        <Col sm={4} md={4} lg={4} xl={4} className="mr-2">
          <div className="hover-image-scale">
            <Image src="images/home5.png" width={350} height={350} alt="Kromsan" className="hover-image-scale" />
          </div>
        </Col>
        <Col sm={4} md={4} lg={4} xl={4} className="mr-2">
          <div className="hover-image-scale">
            <Image src="images/home6.png" width={350} height={350} alt="Kromsan" className="hover-image-scale" />
          </div>
        </Col>
      </Row>
      </Container>
    <ScrollAnimation animateIn="animate__slideInLeft">
    <hr className="featurette-divider"></hr>
 <div className="row featurette">
      <div className="col-md-7">
        <h1 className="featurette-heading fw-normal lh-1">Надежное партнерство</h1>
        <p>Надежное партнерство с KROMSAN в области промышленного оборудования и мебели из нержавеющей стали - это залог успешного и процветающего бизнеса.
           Мы приглашаем вас стать частью нашей семьи клиентов, которым мы готовы предложить выдающийся сервис и индивидуальные решения, специально разработанные 
           под ваши уникальные потребности.
Выбирая KROMSAN в качестве вашего партнера, вы получаете доступ к опытному коллективу профессионалов, 
готовых поддерживать вас на каждом этапе. Мы стремимся к тому, чтобы наше партнерство было основано на взаимном доверии, ответственности и взаимопонимании.
Наша мебель из нержавеющей стали, производимая с использованием передовых технологий и высококачественных материалов,
 является надежным решением для различных отраслей. Мы предлагаем не только продукцию высшего качества, но и уникальные решения, спроектированные с учетом ваших требований.
Вместе с KROMSAN вы можете быть уверены в надежности оборудования, высоком уровне сервиса и гибких подходах к удовлетворению ваших потребностей.
 Доверьтесь нам, и мы сделаем все возможное, чтобы ваш бизнес процветал и развивался.</p>
      </div>
      <div className="col-md-5 pb-3">
      <Image src="/images/img_003.jpg" width={300} height={300}/>
      </div>
    </div>
    
    </ScrollAnimation>
    </div>
        </div>
    );
}

export default Home;